import { useState, useEffect } from "react";
import { X } from "lucide-react";
import ResponsiveAdBanner from "./Anuncios/ResponsiveAdBanner";

// Modal reutilizable que abre un juego con countdown, publicidad y iframe.
// Encapsula toda la experiencia idéntica a la de GamesScreen.
const GameLauncher = ({ gameUrl, onClose }) => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [countdown, setCountdown] = useState(4);
  const [showCloseButton, setShowCloseButton] = useState(false);

  // Al recibir un gameUrl nuevo, iniciar countdown
  useEffect(() => {
    if (gameUrl) {
      setShowCountdown(true);
      setCountdown(4);
      setShowCloseButton(false);
    }
  }, [gameUrl]);

  // Timer del countdown
  useEffect(() => {
    if (showCountdown && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (showCountdown && countdown === 0) {
      setShowCloseButton(true);
    }
  }, [showCountdown, countdown]);

  // Social bar de Adsterra durante el countdown
  useEffect(() => {
    if (showCountdown) {
      const scriptId = "adsterra-social-bar-script";
      if (document.getElementById(scriptId)) return;

      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://pl28457202.effectivegatecpm.com/25/a0/71/25a071f557db1f342cd32743973b201d.js";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        const existingScript = document.getElementById(scriptId);
        if (existingScript) existingScript.remove();
      };
    }
  }, [showCountdown]);

  if (!gameUrl) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex justify-center items-center flex-col">
      <div className="relative w-full max-w-5xl h-[80vh]">
        <iframe
          src={gameUrl}
          title="Juego"
          className="w-full h-full rounded-xl border-none"
          allowFullScreen
        />

        <button
          onClick={onClose}
          className="absolute top-12 left-0 bg-white text-black px-6 py-4 rounded-r-full rounded-l-none font-bold flex items-center gap-1 z-[9999] shadow-md"
        >
          ←
        </button>

        {/* Vignette Monetag aislado en iframe */}
        {showCountdown && (
          <iframe
            title="vignette-ad"
            srcDoc={`<!DOCTYPE html><html><body style="margin:0;padding:0;"><script>(function(s){s.dataset.zone='11277326',s.src='https://n6wxm.com/vignette.min.js'})([document.documentElement, document.body].filter(Boolean).pop().appendChild(document.createElement('script')))</script></body></html>`}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0,
              zIndex: 9999,
            }}
          />
        )}

        {/* Countdown Overlay */}
        {showCountdown && (
          <div className="absolute inset-0 flex items-center justify-center z-[10000]">
            <div className="w-4/5 h-4/5 bg-black bg-opacity-95 rounded-lg flex flex-col items-center justify-center relative shadow-2xl">
              <h2 className="text-white text-4xl font-bold mb-4 text-center px-4">
                El juego comenzará en:
              </h2>
              <p className="text-white text-6xl font-mono mb-8">{countdown}</p>
              {showCloseButton && (
                <button
                  onClick={() => setShowCountdown(false)}
                  className="absolute top-4 right-4 text-white hover:text-gray-300"
                >
                  <X size={40} />
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Banner inferior mientras se juega */}
      <div className="mt-4 w-full flex justify-center z-50">
        <ResponsiveAdBanner position="game" />
      </div>
    </div>
  );
};

export default GameLauncher;
